
export const mockCheckoutRedirect = '/en-us/groups/test-group';

export const mockCheckoutItem: any = {"teamMemberID":"c6a24e8c-73dc-441a-a8ae-41eb31ccaea9","quantity":500,"itemType":10};
